"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHideNextJsErrorOverlay = void 0;
var _react = require("react");
/* istanbul ignore file @preserve --Not testable in Jest environment */

const OVERLAY_SELECTOR = 'nextjs-portal';
const OVERLAY_CLASSNAME = 'hidden-nextjs-overlay';
const BODY_CLASSNAME = 'overlay-hidden';
const hideOverlay = element => {
  const styleEl = document.createElement('style');
  styleEl.innerHTML = `
    .${OVERLAY_CLASSNAME} {
      display: none !important;
    }
    body.${BODY_CLASSNAME} {
      overflow: auto !important;
    }
  `;
  document.head.append(styleEl);
  document.body.classList.add(BODY_CLASSNAME);
  element.classList.add(OVERLAY_CLASSNAME);
  const styleObserver = new MutationObserver(() => {
    if (element.style.display !== 'none') {
      element.classList.add(OVERLAY_CLASSNAME);
    }
  });
  styleObserver.observe(element, {
    attributes: true,
    attributeFilter: ['style']
  });
};
const checkForOverlay = () => {
  const overlay = document.querySelector(OVERLAY_SELECTOR);
  if (overlay instanceof HTMLElement) {
    hideOverlay(overlay);
    return true;
  }
  return false;
};
const setupOverlayDetection = () => {
  if (!checkForOverlay()) {
    const bodyObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node instanceof HTMLElement && node.nodeName.toLowerCase() === OVERLAY_SELECTOR) {
            hideOverlay(node);
            bodyObserver.disconnect();
            return;
          }
        }
      }
    });
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
};

/**
 * Hides the Next.js error overlay in development mode.
 *
 * @note Only works when NEXT_PUBLIC_HIDE_NEXT_ERROR_OVERLAY is set to 'true'
 * in your environment variables.
 */
const useHideNextJsErrorOverlay = () => {
  (0, _react.useEffect)(() => {
    if (process.env.NEXT_PUBLIC_HIDE_NEXT_ERROR_OVERLAY !== 'true') {
      return;
    }
    setupOverlayDetection();
  }, []);
};
exports.useHideNextJsErrorOverlay = useHideNextJsErrorOverlay;
//# sourceMappingURL=useHideNextJsErrorOverlay.js.map